import { useSelector } from "react-redux";

const useReportData = () => useSelector((state) => state.report || {});

export default useReportData;
